import React, { createContext, useContext, useState } from "react";
interface BatchDetailsData {
  [key: string]: any;
}

interface MyBatchContextType {
  batchDetailsData: BatchDetailsData | null;
  setbatchDetailsData: any;
  loading: boolean;
  myBatchFilter: any;
  setMyBatchFilter: any;
  selectedTabIndex: string;
  setSelectedTabIndex: any;
  myBatchTestsTabState: any;
  setMyBatchTestsTabState: any;
}

const MyBatchContext = createContext<MyBatchContextType | null>(null);

export const MyBatchContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [batchDetailsData, setbatchDetailsData] =
    useState<BatchDetailsData | null>(null);
  const [myBatchFilter, setMyBatchFilter] = useState<any>(null);
  const [selectedTabIndex, setSelectedTabIndex] = useState<string>("1");
  const [myBatchTestsTabState, setMyBatchTestsTabState] = useState<any>({
    selectedType: "PAST",
    pagination: {
      pageSize: 10,
      total: 0,
      pageSizeOptions: ["10", "50", "100"],
      showSizeChanger: true,
      current: 1,
    },
  });

  const values: any = {
    batchDetailsData,
    setbatchDetailsData,
    myBatchFilter,
    setMyBatchFilter,
    selectedTabIndex,
    setSelectedTabIndex,
    myBatchTestsTabState,
    setMyBatchTestsTabState,
  };

  return (
    <MyBatchContext.Provider value={values}>{children}</MyBatchContext.Provider>
  );
};

export const useMyBatchContext = (): MyBatchContextType => {
  const context = useContext(MyBatchContext);
  if (!context)
    throw new Error(
      "useMyBatchContext must be used within MyBatchContextProvider"
    );
  return context;
};
